module.exports = __webpack_public_path__ + "img/logo.bb1f8249.jpg";